"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentDisplayEvent = void 0;
const componentDisplay_1 = __importDefault(require("./componentDisplay"));
exports.componentDisplayEvent = componentDisplay_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZGF0YVN0cnVjdHVyZXMvZXZlbnRzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDBFQUF1RDtBQUU5QyxnQ0FGRiwwQkFBcUIsQ0FFRSJ9


// WEBPACK FOOTER //
// ../../../../src/dataStructures/events/index.ts